/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated at build time by scripts/generate-build-info.ts
 *
 * Version: 0.3.0
 * Build: 260228133630
 * Generated: 2026-02-28T18:36:30.678Z
 */

export const APP_VERSION = "0.3.0";
export const BUILD_TIMESTAMP = "260228133630";
